<template>
  <div>
    <basic-container>
      <el-card shadow="hover">
        <div slot="header" class="config-header">
          <span class="title">考勤罚款配置</span>
        </div>

        <el-tabs v-model="activeTab" @tab-click="handleTabChange">
          <el-tab-pane label="防水" name="WATERPROOF_PROJECT"></el-tab-pane>
          <el-tab-pane label="吊顶" name="HANG_CEILING"></el-tab-pane>
        </el-tabs>

        <el-form ref="configForm" :model="configForm" label-width="180px" class="config-form" v-loading="loading">
          <template v-if="displayItems.length > 0">
            <el-form-item v-for="item in displayItems" :key="item.configKey" :label="item.label">
              <template v-if="item.type === 'boolean'">
                <el-switch
                  :value="configForm[item.configKey] === 'true'"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="val => configForm[item.configKey] = val ? 'true' : 'false'"
                />
                <span class="unit">关闭时不计算考勤罚款</span>
              </template>
              <template v-else>
                <el-input-number
                  v-model="configForm[item.configKey]"
                  :min="0"
                  :precision="0"
                  :step="1"
                  controls-position="right"
                  style="width: 200px;"
                />
              </template>
            </el-form-item>

            <el-form-item>
              <el-alert
                title="提示：未打进/退场卡仅做提示，不扣款"
                type="info"
                :closable="false"
                show-icon
                style="margin-bottom: 16px;"
              />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" :loading="saveLoading" @click="handleSave">保存配置</el-button>
              <el-button @click="handleReset">恢复默认</el-button>
            </el-form-item>
          </template>

          <el-form-item v-else>
            <el-alert
              title="该业务类型暂无配置，请联系管理员初始化"
              type="warning"
              :closable="false"
              show-icon
            />
          </el-form-item>
        </el-form>
      </el-card>
    </basic-container>
  </div>
</template>

<script>
import {
  getAttendanceConfigList,
  updateAttendanceConfig,
  deleteAttendanceConfig
} from "@/api/work/attendance/index";

const BOOLEAN_VALUES = new Set(["true", "false"]);

export default {
  name: "attendanceConfig",
  data() {
    return {
      activeTab: "WATERPROOF_PROJECT",
      loading: false,
      saveLoading: false,
      configForm: {},
      existingConfigs: []
    };
  },
  computed: {
    displayItems() {
      return this.existingConfigs.map(cfg => ({
        configKey: cfg.configKey,
        label: cfg.remark || cfg.configKey,
        type: BOOLEAN_VALUES.has(cfg.configValue) ? "boolean" : "number",
        existing: cfg
      }));
    }
  },
  created() {
    this.loadConfig();
  },
  methods: {
    handleTabChange() {
      this.loadConfig();
    },

    loadConfig() {
      this.loading = true;
      const params = { projectType: this.activeTab };
      getAttendanceConfigList(params).then(res => {
        this.loading = false;
        if (res.code === "200") {
          const data = JSON.parse(res.data) || [];
          console.log(data)
          this.existingConfigs = Array.isArray(data) ? data : [];
          this.initFormValues();
        } else {
          this.existingConfigs = [];
          this.configForm = {};
          this.$message.error(res.message || "获取配置失败");
        }
      }).catch(() => {
        this.loading = false;
        this.existingConfigs = [];
        this.configForm = {};
        this.$message.error("获取配置异常");
      });
    },

    initFormValues() {
      const form = {};
      this.displayItems.forEach(item => {
        form[item.configKey] = item.type === "boolean"
          ? item.existing.configValue
          : Number(item.existing.configValue);
      });
      this.configForm = form;
    },

    handleSave() {
      this.$confirm("确认保存当前配置？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.saveLoading = true;
        const promises = this.displayItems.map(item => {
          return updateAttendanceConfig({
            id: item.existing.id,
            projectType: this.activeTab,
            configKey: item.configKey,
            configValue: String(this.configForm[item.configKey]),
            remark: item.label
          });
        });

        Promise.all(promises).then(results => {
          this.saveLoading = false;
          const allSuccess = results.every(r => r.code === "200");
          if (allSuccess) {
            this.$message.success("保存成功");
          } else {
            this.$message.warning("部分配置保存失败，请检查");
          }
          this.loadConfig();
        }).catch(() => {
          this.saveLoading = false;
          this.$message.error("保存异常");
        });
      }).catch(() => {});
    },

    handleReset() {
      this.$confirm("确认恢复默认配置？已保存的配置项将被删除。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (this.existingConfigs.length === 0) {
          this.$message.info("当前已是默认配置");
          return;
        }
        this.loading = true;
        const deletePromises = this.existingConfigs.map(cfg => deleteAttendanceConfig(cfg.id));
        Promise.all(deletePromises).then(() => {
          this.loading = false;
          this.$message.success("已恢复默认配置");
          this.existingConfigs = [];
          this.configForm = {};
        }).catch(() => {
          this.loading = false;
          this.$message.error("恢复默认配置失败");
        });
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.config-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.config-header .title {
  font-size: 16px;
  font-weight: bold;
}
.config-form {
  margin-top: 20px;
  max-width: 600px;
}
.unit {
  margin-left: 8px;
  color: #909399;
  font-size: 13px;
}
</style>
